/* eslint-disable max-len */
import React from 'react';

export default function SurveyQuestionIcon() {
  return (
    <svg width="52" height="52" fill="none" viewBox="0 0 52 52">
      <g clipPath="url(#clip0_10353_4258)">
        <path
          fill="url(#paint0_linear_10353_4258)"
          d="M25.595.003a25.912 25.912 0 0126.4 25.482c.04 2.111-.17 4.167-.605 6.138-.736 3.338-1.174 6.735-1.174 10.153v6.607c0 1.012-.82 1.833-1.833 1.833h-6.607c-3.418 0-6.815.438-10.153 1.174a26.117 26.117 0 01-6.138.605 25.912 25.912 0 01-25.482-26.4C.217 11.559 11.557.219 25.595.004z"
        />
        <path
          fill="url(#paint1_linear_10353_4258)"
          d="M51.44 31.389l-.05.234c-.737 3.338-1.174 6.734-1.174 10.153v6.608c0 1.011-.82 1.832-1.833 1.832h-6.607c-.494 0-.987.009-1.48.028L23.42 33.364c-.29-.292-.434-.819-.434-1.58 0-3.34.852-5.743 2.559-7.207.17-.158.517-.437 1.037-.835-.144-.124-8.17-8.182-8.264-8.263-.38-.327-.569-.775-.569-1.341 0-1.017.715-2.012 2.148-2.986 1.431-.974 3.249-1.462 5.45-1.462 2.76 0 4.936.71 6.524 2.127l19.57 19.572z"
        />
        <path
          fill="url(#paint2_linear_10353_4258)"
          d="M38.938 50.314c-2.109.143-4.205.44-6.28.858l-9.586-9.586c-.497-.483-.746-1.045-.746-1.688 0-.67.25-1.24.746-1.708.496-.469 1.11-.703 1.84-.703.748 0 1.397.234 1.944.703l12.082 12.124z"
        />
        <path
          fill="#fff"
          d="M17.748 14.137c0-1.016.715-2.012 2.148-2.986 1.432-.973 3.248-1.46 5.45-1.46 2.76 0 4.935.709 6.524 2.126 1.588 1.418 2.382 3.223 2.382 5.415a8.57 8.57 0 01-.396 2.608 7.935 7.935 0 01-1.144 2.28 24.5 24.5 0 01-1.343 1.71c-.396.453-.895.95-1.497 1.49-.601.542-.96.87-1.075.987-.869.79-1.404 1.593-1.607 2.411-.203.819-.303 2.06-.303 3.727 0 .906-.675 1.359-2.023 1.359-.675 0-1.156-.146-1.446-.439-.289-.293-.433-.82-.433-1.582 0-3.338.853-5.741 2.558-7.206.19-.175.592-.497 1.209-.966.616-.468 1.075-.857 1.377-1.164.301-.308.653-.718 1.056-1.23a5.168 5.168 0 00.884-1.67c.187-.6.281-1.237.281-1.911 0-1.406-.455-2.497-1.366-3.273-.91-.777-2.172-1.165-3.783-1.165-.936 0-1.732.142-2.39.425-.657.284-1.118.604-1.38.962a6.1 6.1 0 01-.878.961c-.322.284-.657.425-1.008.425-.439 0-.848-.164-1.228-.492-.38-.327-.57-.774-.57-1.342zm4.579 25.761c0-.67.248-1.24.745-1.708.496-.468 1.11-.703 1.84-.703.75 0 1.397.235 1.944.703.546.469.82 1.038.82 1.708 0 .643-.273 1.206-.82 1.688a2.84 2.84 0 01-1.944.723c-.73 0-1.344-.24-1.84-.723-.497-.482-.745-1.044-.745-1.688z"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10353_4258"
          x1="16.23"
          x2="51.737"
          y1="16.231"
          y2="51.738"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01A7FA" />
          <stop offset="1" stopColor="#0183EA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10353_4258"
          x1="41.013"
          x2="11.298"
          y1="35.961"
          y2="6.246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A2F3" stopOpacity="0" />
          <stop offset="1" stopColor="#0075CD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10353_4258"
          x1="31.159"
          x2="23.253"
          y1="46.084"
          y2="38.178"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A2F3" stopOpacity="0" />
          <stop offset="1" stopColor="#0075CD" />
        </linearGradient>
        <clipPath id="clip0_10353_4258">
          <path fill="#fff" d="M0 0H52V52H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
